import { useParams } from 'react-router-dom';
import ManagerReviewComp from '../../Components/EmployeesReview/ManagerReviewComp';
import HrReviewComp from '../../Components/EmployeesReview/HrReviewComp';
import DraftReviewComp from '../../Components/EmployeesReview/DraftReviewComp';
import { useEffect, useState } from 'react';
import EmployeesReviewApi from '../../Api/EmployeesReviewApi';
import { toastError } from '../../Components/Toast/ToastComponent';
import CompletedReviewComp from '../../Components/EmployeesReview/CompletedReviewComp';

const STATUS_COMPONENTS = {
  'Hr Review': HrReviewComp,
  'Manager Review': ManagerReviewComp,
  Draft: DraftReviewComp,
  'Draft -> Manager Review': ManagerReviewComp,
  'Draft -> Hr Review': HrReviewComp,
  Completed: CompletedReviewComp,
};

function EmployeesReview() {
  const { reviewId } = useParams();

  const [reviewData, setReviewData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const review = await fetchReviewData();
      if (review) {
        setReviewData({
          ...review,
          employee_review: {
            ...review?.employee_review,
            rating: review?.employee_review_populated,
          },
          manager_review: {
            ...review?.manager_review,
            rating: review?.manager_review_populated,
          },
        });
      }
    };
    fetchData();
    return () => {
      setReviewData(null);
    };
  }, []);

  async function fetchReviewData() {
    try {
      const response = await EmployeesReviewApi.getByDate({
        review_id: reviewId,
      });
      return response?.data?.result || null;
    } catch (error) {
      console.error('Error fetching review data:', error);
      toastError(
        error?.response?.data?.message || 'Failed to fetch review data.',
      );
    }
  }

  const STATUS = reviewData?.status;
  const PREVIOUS_STATUS = reviewData?.previous_status;

  const Component =
    STATUS === 'Draft'
      ? STATUS_COMPONENTS[`Draft -> ${PREVIOUS_STATUS}`]
      : STATUS_COMPONENTS[STATUS];

  return Component ? (
    <Component reviewData={reviewData} />
  ) : (
    <>no review found</>
  );
}

export default EmployeesReview;
